import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Category } from '../../categories/shared';
import { Filter } from './filter.model';
import { FilterValue } from './filter-value.model';

@Injectable()
export class FilterFormService {
  constructor(private fb: FormBuilder) {}

  getForm(filter: Filter = new Filter()): FormGroup {
    return this.fb.group({
      _id: [filter._id],
      name: [filter.name, Validators.required],
      category: [(filter.category) ? filter.category._id : null],
      position: [filter.position],
      active: [filter.active],
      values: this.fb.array(filter.values.map(item => this.getFilterValueForm(item)))
    });  
  }

  getFilterValueForm(filterValue: FilterValue = new FilterValue()): FormGroup {
    return this.fb.group({
      _id: [filterValue._id],
      name: [filterValue.name, Validators.required],
      position: [filterValue.position],
      active: [filterValue.active]
    });
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/shared/filter-form.service.ts